import React from 'react'
import './RecomendedVideos.css'
import VideoCard from './VideoCard'

function RecommendedVideos() {
  return (
    <div className="recomendedVideos">
      <h2>Recommended</h2>
      <div className="recommendedVideos__videos">
        <VideoCard
          title="10 Easy To Make Foods"
          views="257M Views"
          timestamp="1 years ago"
          channelimg="https://media.istockphoto.com/id/1298088270/photo/young-beautiful-smiling-woman-chef-with-arms-crossed-at-kitchen.webp?b=1&s=612x612&w=0&k=20&c=GCL34v_svicQ1BlYgcTyhYQaCTqUycpME_YZHG7sb7E="
          channel="RealFoods"
          image="https://media.istockphoto.com/id/1391235885/photo/tv-cooking-show-in-restaurant-kitchen-portrait-of-black-female-chef-talks-teaches-how-to-cook.jpg?s=612x612&w=0&k=20&c=YBU5l05T9DELHT9bIBWt2SbeDcppa8fhGh9KF1SYSiQ="
        />
        <VideoCard
          title="NF-The Search"
          views="257M Views"
          timestamp="4 years ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://cdn.rapzilla.com/wp-content/uploads/2019/07/23113710/nfrealmusic_36936306_373144113212198_3067719733068431360_n.jpg"
        />
        <VideoCard
          title="NF-The Hope"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://hiphop-n-more.com/wp-content/uploads/2023/02/nf-hope-video-1200x720.jpg"
        />
        <VideoCard
          title="NF - MOTTO"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/0YKOxtOb44c/maxresdefault.jpg"
        />
        <VideoCard
          title="NF, Cordae - CAREFUL (Audio)"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/6gOpVMzwSKs/maxresdefault.jpg"
        />
        <VideoCard
          title="NF-MAMA"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/DRt3-4moku8/maxresdefault.jpg"
        />
        <VideoCard
          title="NF-Happy"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/1rc1H6lJd6E/sddefault.jpg"
        />
        <VideoCard
          title="NF-Pandemonium"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjQcRZhjq1n6ib8QAhrdcUy59QG4Ga3CRCwA&usqp=CAU"
        />
        <VideoCard
          title="NF- Suffice"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/qicOnol9zF4/sddefault.jpg"
        />
        <VideoCard
          title="NF- Gone"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/HkPzCqQCMqE/maxresdefault.jpg"
        />
        <VideoCard
          title="NF-Bullet"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/VUcsYWawaF0/maxresdefault.jpg"
        />
        <VideoCard
          title="NF-Turn My Back"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/aUvVnti59xk/maxresdefault.jpg"
        />
        <VideoCard
          title="NF- Mistake"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/2eeo2dPyg4Q/sddefault.jpg"
        />
        <VideoCard
          title="NF- Let Em Pray"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/iUp6NNsv2pg/sddefault.jpg"
        />
        <VideoCard
          title="NF- Running"
          views="257M Views"
          timestamp="10 months ago"
          channelimg="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/NF_photo_2016.jpg/220px-NF_photo_2016.jpg"
          channel="NFrealmusic"
          image="https://i.ytimg.com/vi/SVIQrU2EZZU/maxresdefault.jpg"
        />
      </div>
    </div>
  )
}

export default RecommendedVideos
